export const navCopy = {
  skip_to_content: "Saltar al contenido principal",
  nav_documentation: "Documentación",
  nav_documentation_short: "Docs",
  nav_download: "Descargar",
  nav_community: "Conectar",
  nav_tools: "Probar TypeScript!",
  nav_search_placeholder: "Buscar en documentación",
  nav_search_aria: "Búsqueda en el sitio de TypeScript",
}
